<template>
  <div class="wrap">
    <div class="top-title">提现金额</div>
    <div class="input-wrap">
      <div>
        <span class="iconfont icon-renminbi2"></span>
      </div>
      <div style="flex:1;">
        <input type="number" v-model="money">
      </div>
    </div>
    <!-- <div class="extra">已扣税可提现金额200元，未扣税68元</div> -->
    <div class="btn" @click="showConfirm">提现</div>
    <div class="mx"><router-link to="/personal/wallet/txmx" tag="span">提现明细</router-link></div>
    <div class="desc">可提现金额: <span>{{all}}</span> 元</div>
    <!-- 提现确认框 -->
    <popup :showClose="false" ref="confirm">
      <div class="confirm">
        <!-- <div class="title">申请提现金额：{{money}}元</div>
        <div class="con border-bottom">
          <table>
            <tr>
              <td>待扣税金额</td>
              <td><div class="line"></div></td>
              <td class="value">100元</td>
            </tr>
            <tr>
              <td>待扣税金额</td>
              <td><div class="line"></div></td>
              <td class="value">20元</td>
            </tr>
            <tr>
              <td>待扣税金额</td>
              <td><div class="line"></div></td>
              <td class="value">20元</td>
            </tr>
          </table>
        </div>
        <div class="sum">实际到账：180元</div> -->
        <div class="sum">申请提现金额：{{money}}元</div>
        <div class="btn" @click="submit">确认提交</div>
      </div>
    </popup>
    <div class="trigger" @click="showPopup">收益提现说明</div>
    <popup ref="popup">
      <div class="income">
        <div class="title">收益提现说明</div>
        <p>1.用户收入优先进入待结算，7天后进行扣税并可提现</p>
        <p>2.累计收入为用户全部收入之和</p>
        <p>3.可提现金额为当前已扣税可以提现的金额</p>
        <p>4.扣税：根据法律法规的相关规定平台将根据用户获得的收入进行扣税，具体扣税规则如下（月总收入计算）</p>
        <p class="sub">⑴收入金额在800以内不扣税</p>
        <p class="sub">⑵收入金额N (800&lt;N)，扣税金额为（N-800）*20%</p>
        <p>5.当订单进入可提现时系统根据当月收入自动扣税，请知悉</p>
        <p>6.每笔提现金额至少5元，微信官方收取1%手续费</p>
        <p>7.用户每日提现上限为1万元，每天最多提现3次</p>
        <p>8.如需帮助，请联系客服微信号：golo444 最终解释权归golo课堂运营方所有</p>
      </div>
    </popup>
  </div>
</template>

<script>
import Popup from 'components/base/ui/popup'
import {submitWithdraw} from '@/api/user-center'
import {RES_OK} from '@/api/config'
export default {
  data() {
    return {
      money: '',
      all: 0
    }
  },
  created() {
    // 总的金额，从上个页面传下来的
    this.all = (this.$route.query.all && Number(this.$route.query.all)) || 0
  },
  methods: {
    showConfirm() {
      if (!this.check()) {
        return
      }
      this.$refs.confirm.show()
    },
    showPopup() {
      this.$refs.popup.show()
    },
    check() {
      if (!/^[\d]+(\.[\d]{1,2})?$/.test(this.money)) {
        this.$toast('请输入正确提现金额')
        return false
      }
      if (this.money > this.all || this.money <= 0) {
        this.$toast('提现金额不能大于可提现金额')
        return false
      }
      if (this.money < 5) {
        this.$toast('提现金额最低为5元')
        return false
      }
      return true
    },
    submit() {
      if (!this.check()) {
        return
      }
      submitWithdraw(this.money, this.all).then((res) => {
        let data = res.data
        if (data && data.code === RES_OK) {
          this.$toast('提现申请已经成功提交')
          this.money = ''
          this.$refs.confirm.close()
        } else if (data && data.msg) {
          this.$toast(data.msg)
        }
      })
    }
  },
  components: {
    Popup
  }
}
</script>

<style scoped lang="stylus" ref="stylesheet/stylus">
  @import "~common/stylus/variable"
  .wrap
    padding 0 size(30)
  .top-title
    color #131313
    font-size size(26)
    margin size(40) 0
  .input-wrap
    display flex
    align-items center
    border-bottom 1px solid #d4d4d4
    color #000000
    padding 0 size(12)
    padding-bottom size(12)
    span
      font-size size(38)
      font-weight 500
      display inline-block
      position relative
      top 6px
    input
      width 100%
      font-size size(80)
      outline none
      padding-left size(10)
  .extra
    font-size size(24)
    color #717171
    padding size(20) 0
  .btn
    background $color-theme
    line-height size(88)
    border-radius 5px
    text-align center
    color #fff
    font-size size(34)
    margin-top size(36)
  .mx
    text-align right
    font-size size(28)
    color #5e5e5e
    margin-top size(34)
    padding-right 4px
  .trigger
    position fixed
    text-align center
    left 0
    right 0
    bottom size(36)
    font-size size(24)
    color #575756
  .income
    padding 0 size(38 - 22) size(40)
    .title
      font-size size(30)
      color #0e0e0e
      text-align center
      font-weight 800
      margin size(28) 0 size(22)
    p
      font-size size(24)
      line-height 1.4
      color #2c2c2c
      margin size(12) 0
    .sub
      color #525151
  .confirm
    .title
      font-size size(34)
      font-weight 800
      color #0e0e0e
      text-align center
    .con
      margin 0 size(28)
      padding size(24) size(26) size(6)
      &:before
        background-color #d8d8d8
    .line
      border dashed 1px #979797
      transform scaleY(.5)
      width size(188)
      margin 0 size(12)
    .value
      text-align right
    table
      font-size size(28)
      color #3b3b3b
      tr
        height size(50)
      td
        vertical-align middle
    .sum
      font-size size(30)
      color #0b0b0b
      text-align center
      margin size(34) 0
    .btn
      width size(216)
      line-height size(72)
      color #ffffff
      background $color-theme
      border-radius 8px
      font-size size(28)
      margin 0 auto
  .desc{
    margin-top: size(50);
    color: #333;
    font-size: size(32);
    span{
      color: #ff6c00
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/personal/wallet/wallet-tx.vue